import { TasksKanbanGroupingModel, DragModel } from ".";

/**Модель с информацией о колонке */
export class TasksKanbanColumnModel {
  /**Описание группировки для колонки */
  Grouping?: TasksKanbanGroupingModel;
  /**Задачи в колонке */
  Data?: Array<DragModel<{ TaskId: number }>>;
  /**Кол-во задач */
  CountTasks?: number;
  /**Загрузка */
  IsLoading?: boolean = false;

  constructor(obj?: Partial<TasksKanbanColumnModel>) {
    Object.assign(this, obj);
  }
}
